export default __webpack_public_path__ + "static/careers-benefits-block1-icon10.url-3b41dc479e9d2c91f4b44363bbcffba6.svg";